import { render, staticRenderFns } from "./ListInvestigations.vue?vue&type=template&id=68f78ebc&scoped=true"
import script from "./ListInvestigations.vue?vue&type=script&lang=js"
export * from "./ListInvestigations.vue?vue&type=script&lang=js"
import style0 from "./ListInvestigations.vue?vue&type=style&index=0&id=68f78ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f78ebc",
  null
  
)

export default component.exports